import { AvantArteLogo } from '@design-system';
import { useRouter } from 'next/router';
import React from 'react';

import { HideHubspot } from '../../../../components/HideHubspot';
import Head from '../../../../components/Layout/Head';
import SocialMetadata from '../../../../components/SocialMetadata';
import { imageLoader } from '../../../../helpers/images';
import { toCanonicalUrl, urlFor } from '../../../../helpers/links';
import { GeneratedPrivateLink } from '../../../../types/generated';

type Props = {
  privateLink: GeneratedPrivateLink;
  locale: string;
  children?: React.ReactNode;
  ogImageUrl: string;
};

export const Layout: React.FC<Props> = (props: Props) => {
  const { children, locale, ogImageUrl, privateLink } = props;
  const { asPath } = useRouter();

  const fallbackCanonicalUrl = toCanonicalUrl({
    path: asPath,
    locale,
    hostname: process.env.NEXT_PUBLIC_HOSTNAME!,
  });

  return (
    <main className="bg-neutral-6" id="private-room">
      <Head
        description={privateLink.strapline}
        theme="dark"
        title={privateLink.heading}
        urls={{ canonical: fallbackCanonicalUrl }}
      />
      <SocialMetadata
        description={privateLink.strapline}
        imageUrl={ogImageUrl}
        title={privateLink.heading}
        type="website"
        url={urlFor({ page: 'PRIVATE_LINK', slug: privateLink.slug })}
      />
      <div
        className="duration-400 h-full w-full bg-fixed bg-center transition-all ease-in-out"
        style={{
          backgroundImage: `url('${imageLoader({
            src: privateLink.imageUrl,
            width: 1200,
          })}')`,
        }}
      >
        <div className="flex min-h-screen flex-col bg-neutral-6/60 backdrop-blur-[30px]">
          <div className="flex h-14 items-center justify-center border-b border-white/20 text-white md:h-18">
            <AvantArteLogo className="max-md:hidden" variant="wordmark" />
            <AvantArteLogo className="md:hidden" variant="icon" />
          </div>
          <div className="flex h-full flex-1 flex-col items-center">
            {children}
          </div>
        </div>
      </div>
      <HideHubspot />
    </main>
  );
};
